/* @flow */
export default {
  NODE_ENV: process.env.NODE_ENV,
  IS_ENV_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_ENV_PRODUCTION: process.env.NODE_ENV === 'production',
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '',
  STATIC_ASSETS_URL: process.env.REACT_APP_STATIC_ASSETS_URL || '',
  DISPLAY_VERSION: process.env.REACT_APP_DISPLAY_VERSION,
  REDUX_PERSIST_REDUCER_VERSION: process.env.REACT_APP_REDUX_PERSIST_REDUCER_VERSION || '1',
  REDUX_PERSIST_ACTIVE: true,
  KEYCLOAK_REALM: process.env.REACT_APP_KEYCLOAK_REALM || 'protones',
  KEYCLOAK_URL: process.env.REACT_APP_KEYCLOAK_URL || '',
  KEYCLOAK_CLIENT_ID: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'protones-ui',
};
